import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { ConversionFailure } from '../data/convertCompareCount';

interface ConversionResult {
  readonly numberOfFilesSubmitted: number;
  readonly failedConversions: readonly ConversionFailure[];
  readonly guid: string;
}

const initialState: readonly ConversionResult[] = [];

const conversionResultsSlice = createSlice({
  name: 'conversionResults',
  initialState: initialState as readonly ConversionResult[],
  reducers: {
    addConversionResult: (state, action: PayloadAction<ConversionResult>) => {
      state.push(castDraft(action.payload));
    },
  },
});

export const { addConversionResult } = conversionResultsSlice.actions;
export const conversionResults = conversionResultsSlice.reducer;
